import { Injectable, signal, effect } from "@angular/core";
import { MessageService } from "primeng/api";

export interface ToastMessage {
  severity: "success" | "error" | "info" | "warn";
  summary: string;
  detail: string;
  life?: number;
  enableHtml?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class JniToastrService {
  private toastMessageSignal = signal<ToastMessage | null>(null);

  constructor(private toastr: MessageService) {
    effect(() => {
      const message = this.toastMessageSignal();
      if (message) {
        this.toastr.add(message);
      }
    });
  }

  success(detail: string, summary = "Success") {
    if (detail.toLowerCase() == "success") {
      detail = "";
    }
    this.toastMessageSignal.set({
      severity: "success",
      summary,
      detail,
      life: 3000,
    });
  }

  error(detail: string, summary = "Error", enableHtml = false) {
    this.toastMessageSignal.set({
      severity: "error",
      summary,
      detail,
      life: 3000,
      enableHtml: enableHtml,
    });
  }

  info(detail: string, summary = "Info") {
    this.toastMessageSignal.set({
      severity: "info",
      summary,
      detail,
      life: 3000,
    });
  }

  warning(detail: string, summary = "Warning") {
    this.toastMessageSignal.set({
      severity: "warn",
      summary,
      detail,
      life: 3000,
    });
  }
}
